import React from 'react';

import './index.module.less';

import { IProps } from './index.d';

const CommonBtn = (props: IProps) => {
  const { style, className, type, btnText, disabled, onConfirm } = props;

  const clickBtn = () => {
    if (disabled) {
      return;
    }
    onConfirm && onConfirm();
  };
  const BtnContent = (
    <div
      className="flex flex-center"
      styleName={'btn ' + (className || '') + (disabled ? ' disabled' : '')}
      style={{ ...(style || {}) }}
      onClick={clickBtn}
    >
      {btnText || '确定'}
    </div>
  );

  if (!type || type === 'auto') {
    return BtnContent;
  }

  return (
    <div className="flex flex-center" styleName="bottom">
      {BtnContent}
    </div>
  );
};

export default CommonBtn;
